module.exports = __webpack_public_path__ + "static/media/corporate-thumbnail.daae3035.png";